import React, { KeyboardEvent } from "react";

export default function makeEnterKeyPressHandler(
  handler: (e?: React.SyntheticEvent) => void,
): (e: KeyboardEvent) => void {
  return (e: KeyboardEvent) => {
    e?.key === "Enter" && handler();
  };
}
